<template>
  <div class="home">
    <div class="banner">
      <div class="bannertext">
        <div class="type">
          <span>{{ H.title }}</span>
        </div>
        <div class="text1">{{ H.subTitle }}</div>
        <div class="text2">{{ H.subTitle2 }}</div>
      </div>
    </div>

    <div class="solu">
      <div class="left">
        <div class="title">{{ H.stop }}</div>
        <div class="text">{{ H.team }}</div>
        <div class="checkitem">
          <div class="item" v-for="(e, i) in S.present" :key="i" @click="tabE(i)">
            {{ e.big_title }}
            <div :class="tabindex == i ? 'san' : ''"></div>
          </div>
        </div>

        <div class="right">
          <swiper :options="typeD" ref="sw" @slideChange="typeDE">
            <swiper-slide ref="" v-for="(item, index) in S.present" :key="index">
              <div class="rightbox">
                <div class="img">
                  <img :src="item.image1" alt="" />
                </div>
                <div class="right-text">
                  {{ item.text }}
                </div>
                <div class="more" @click="toserE(index)">
                  {{ H.more }}
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>

    <div class="about">
      <div class="top">
        <div class="box">
          <div class="num one">10</div>
          <div class="zi">
            <span>{{ H.port }}</span>
          </div>
        </div>
        <div class="box">
          <div class="num">8</div>
          <div class="zi">
            <span>{{ H.airports }}</span>
          </div>
        </div>
        <div class="box">
          <div class="num">200<span>+</span></div>
          <div class="zi">
            <span>{{ H.regions }}</span>
          </div>
        </div>
        <div class="box">
          <div class="num">100<span>+</span></div>
          <div class="zi">
            <span>{{ H.covered }}</span>
          </div>
        </div>
      </div>
      <div class="bot">
        <div class="title">{{ H.about }}</div>
        <div class="subTitle">{{ H.logistic }}</div>
        <div class="bot_box">
          <div class="text">
            {{ H.about_title }}<br /><br />
            {{ H.about_text }}
          </div>
          <div class="but" @click="toabout">{{ H.us }}</div>
        </div>
      </div>
    </div>

    <div class="selects">
      <div class="title">{{ H.choose }}</div>
      <div class="subTitle">{{ H.team }}</div>
      <div class="flex_box">
        <div class="item one">
          <div class="oriC">
            <img src="../../static/img/my.png" alt="" />
            <div class="mt43">{{ H.solutions }}</div>
          </div>
          <div class="mask">
            <div class="bod1"></div>
            <div class="bod2"></div>
            <div class="bod3"></div>
            <div class="bod4"></div>
            <div class="masktitle">{{ H.solutions }}</div>
            <div class="masktext">
              {{ H.solutions_text }}
            </div>
          </div>
        </div>
        <div class="item one two">
          <div class="oriC">
            <img src="../../static/img/my.png" alt="" />
            <div class="mt43">{{ H.price }}</div>
          </div>
          <div class="mask">
            <div class="bod1"></div>
            <div class="bod2"></div>
            <div class="bod3"></div>
            <div class="bod4"></div>
            <div class="masktitle">{{ H.price }}</div>
            <div class="masktext">
              {{ H.price_text }}
            </div>
          </div>
        </div>
        <div class="item one three">
          <div class="oriC">
            <img src="../../static/img/wl.png" alt="" />
            <div class="mt43">{{ H.industrial }}</div>
          </div>

          <div class="mask">
            <div class="bod1"></div>
            <div class="bod2"></div>
            <div class="bod3"></div>
            <div class="bod4"></div>
            <div class="masktitle">{{ H.industrial }}</div>
            <div class="masktext">
              {{ H.industrial_text }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="assess">
      <div class="title">
        {{ H.others_title }}
      </div>
      <div class="subTitle">
        {{ H.others_subTitle }}
      </div>
      <div class="swiper">
        <swiper :options="revD">
          <swiper-slide v-for="(item, index) in H.evaArr" :key="index">
            <div class="box">
              <div class="text" v-html="item.title"></div>
              <div class="but">{{ item.name }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="partner">
      <div class="title">{{ H.partners }}</div>
      <div class="logo">
        <img  src="../../static/img/logo100.png" alt="" />
      </div>
    </div>
    <!-- <div class="partner">
      <div class="title">{{ H.partners }}</div>
      <div class="logo">
        <div class="icon  ">
          <img class="icon1" src="../../static/img/logo1.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon2" src="../../static/img/logo2.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon3" src="../../static/img/logo3.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon4" src="../../static/img/logo4.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon5" src="../../static/img/logo5.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon6" src="../../static/img/logo6.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon7" src="../../static/img/logo7.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon8" src="../../static/img/logo8.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon9" src="../../static/img/logo9.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon10" src="../../static/img/logo10.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon11" src="../../static/img/logo11.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon12" src="../../static/img/logo12.png" alt="" />
        </div>
      </div>
    </div> -->

    <!-- <div class="partner">
      <div class="title">{{ H.partners }}</div>
      <div class="box">
        <div class="line1">
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo101.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo102.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo103.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo104.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="line2">
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo105.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo106.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo107.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="line2">
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo108.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo109.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo110.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo111.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="line2">
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo112.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo113.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo114.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="line2">
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo115.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo116.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo117.png" alt="">
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="box2">
              <div class="box3">
                <img src="../../static/img/logo118.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import moveArr from "../../static/movedata/index";
import text from "../../static/data/text";
export default {
  name: "home",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      tabindex: 0,
      lan: "cn",
      allTimeline: null,
      typeD: {
        loop: true,
        autoplay: true
      },
      revD: {
        loop: true,
        autoplay: true,
        slidesPerView: 1
      },
    };
  },
  computed: {
    H() {
      return text[this.lan]["home"];
    },
    S() {
      return text[this.lan]["service"];
    }
  },
  mounted() {
    if (document.body.style.zoom > 0.95) {
      window.addEventListener("scroll", this.scrollToTop, true);
      this.initaniE();
    }
  },
  methods: {
    toserE(index) {
      this.$router.push({ path: "/services", query: { num: index } });
    },
    typeDE() {
      this.tabindex = this.$refs.sw.$swiper.activeIndex - 1;
    },
    tabE(i) {
      this.tabindex = i;
      // this.$refs.sw.$swiper.activeIndex = i;
      this.$refs.sw.$swiper.slideTo(i + 1);
    },
    initaniE() {
      this.allTimeline = new TimelineMax({ paused: true });
      let scrollAnimationObj = moveArr;
      for (let i = 0; i < scrollAnimationObj.length; i++) {
        let bwTimeline = new TimelineMax({
          delay: scrollAnimationObj[i].distancetop / 5725
        });
        let bwTween = TweenMax.fromTo(
          scrollAnimationObj[i].ele,

          scrollAnimationObj[i].distancebottom / 5725,
          scrollAnimationObj[i].from,
          scrollAnimationObj[i].to
        );
        bwTimeline.add(bwTween, 0);
        this.allTimeline.add(bwTimeline, 0);
      }
    },
    toabout() {
      this.$router.push("/about");
    },
    scrollToTop() {
      // if()
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      console.log(scrollTop);
      this.allTimeline.seek(scrollTop / 5725);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.solu .san {
  width: 0;
  height: 0;
  border-color: transparent #fff transparent transparent;
  border-style: solid;
  border-width: 14px 6px 0 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateY(-78%) translatex(-60%) rotate(90deg);
  /* top: 93px; */
}

.home {
  width: 100%;
  overflow-x: hidden;
}

.banner {
  height: 932px;
  background: url("/static/img/homebanner.png") no-repeat fixed;
  padding-top: 364px;
  box-sizing: border-box;
  text-align: center;
}

.bannertext {
  display: inline-block;
  width: 669px;
  border-top: 1px solid #ffffff;
  border-bottom: 1px solid #ffffff;
  transition: all 0.5s;
}

.banner .type {
  font-size: 20px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #3474f5;
  padding-top: 33px;
  margin-bottom: 27px;
}

.banner .type span {
  margin-right: 15px;
}

.banner .text1 {
  font-size: 55px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
}

.banner .text2 {
  font-size: 40px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
}

.banner .text {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
}

.pb50 {
  padding-bottom: 50px;
}

.solu {
  height: 1070px;

  position: relative;
  top: -100px;
}

.solu .left {
  width: 1476px;
  background: #3472ef;
  height: 100%;
  box-sizing: border-box;
  padding-top: 158px;
  position: relative;
  /* padding-left: 408px; */
  transition: all 0.5s;
}

.solu .left .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  padding-left: 533px;
  margin-bottom: 25px;
  line-height: 1;
}

.solu .left .text {
  font-size: 20px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #062667;
  line-height: 21px;
  padding-left: 750px;
}

.solu .left .checkitem {
  margin-top: 99px;
  position: relative;
}

.solu .left .checkitem .item {
  width: 357px;
  margin-left: 288px;
  padding: 37px 0;
  border-top: 1px solid #ffffff;
  font-size: 27px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  line-height: 1;
  position: relative;
}

.solu .right {
  width: 1464px;
  height: 552px;

  position: absolute;
  right: -751px;
  transition: all 0.8s;
  top: 369px;
}

.solu .right .swiper-container {
  width: 100%;
  height: 100%;
}

.rightbox {
  position: absolute;
  width: 100%;
  height: 100%;
  /*background: url("../../static/img/solu1.jpg") no-repeat center center;*/
  background-size: 1464px 552px;
  cursor: pointer;
}

.rightbox .img {
  width: 1464px;
  height: 552px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.rightbox .img img {
  width: 1464px;
  height: 552px;
}

.solu .right .right-text {
  margin: 111px 535px 0 156px;
  font-size: 25px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 45px;
}

.solu .right .more {
  width: 96px;
  font-size: 24px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 45px;
  margin: 50px 0 0 156px;
  border-bottom: 2px solid #3472ef;
  cursor: pointer;
}

/* about */
.about .top {
  display: flex;
  justify-content: space-between;
  padding: 0 247px;
  transition: all 0.5s;
}

.about .top .box {
  display: flex;
}

.about .top .box .num {
  font-size: 165px;
  font-family: Teko-Regular, Teko;
  font-weight: 400;
  color: #3472ef;
  line-height: 222px;
  margin-right: 20px;
  letter-spacing: -10px;
}

.about .top .box .num.one {
  letter-spacing: -20px;
}

.about .top .box .num span {
  font-size: 34px;
}

.about .top .box .zi {
  font-size: 24px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  line-height: 21px;
}

.about .top .box .zi span {
  display: inline-block;
  margin-top: 154px;
}

.about .bot {
  height: 616px;
  margin-top: 48px;
  background: url("../../static/img/about.png") no-repeat right center;
  background-size: 1633px 616px;
  position: relative;
  transition: all 0.5s;
}

.about .bot .title {
  padding-top: 164px;
  margin-left: 462px;
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 87px;
}

.about .bot .subTitle {
  font-size: 20px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 21px;
  margin-left: 462px;
  margin-top: 27px;
}

.about .bot .bot_box {
  width: 1167px;
  height: 800px;
  background: #fff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1608);
  margin-left: 462px;
  position: absolute;
  left: 0;
  bottom: -316px;
  transition: all 0.3s;
}

.about .bot .bot_box .text {
  width: 870px;
  font-size: 25px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #5b5b5b;
  line-height: 45px;
  margin-left: 94px;
  padding-top: 73px;
}

.about .bot .bot_box .but {
  width: 304px;
  height: 93px;
  background: #3472ef;
  border-radius: 47px 47px 47px 47px;
  opacity: 1;
  font-size: 33px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 93px;
  text-align: center;
  margin-left: 94px;
  margin-top: 80px;
}

/* select */
.selects {
  margin-top: 462px;
}

.selects .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  line-height: 87px;
  text-align: center;
}

.selects .subTitle {
  font-size: 20px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #3472ef;
  line-height: 21px;
  text-align: center;
  margin-top: 27px;
}

.selects .flex_box {
  display: flex;
  margin-top: 68px;
}

.selects .flex_box .item {
  flex: 1;
  height: 408px;
  text-align: center;
  transition: all 0.5s;
  cursor: pointer;
  position: relative;
  padding-top: 43px;
  box-sizing: border-box;
}

.mask {
  position: absolute;
  background: #3472ef;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  line-height: 0;
  z-index: 2;
  transition: all 0.5s;
  box-sizing: border-box;
  display: none;
  /* padding: 40px; */
}

.mask .masktitle {
  position: absolute;
  left: 0;
  right: 0;
  font-size: 35px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  margin-top: 123px;
}

.mask .masktext {
  position: absolute;
  left: 0;
  right: 0;
  font-size: 20px !important;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  color: #ffffff;
  margin-top: 208px;
  padding: 0 135px;
  line-height: 35px !important;
}

.bod1 {
  /* width: 9px; */
  width: 28px;
  height: 28px;
  border-left: 9px solid #fff;
  border-top: 9px solid #fff;
  position: absolute;
  left: 40px;
  top: 40px;
}

.bod2 {
  /* width: 9px; */
  width: 28px;
  height: 28px;
  border-right: 9px solid #fff;
  border-top: 9px solid #fff;
  position: absolute;
  right: 40px;
  top: 40px;
}

.bod3 {
  /* width: 9px; */
  width: 28px;
  height: 28px;
  border-left: 9px solid #fff;
  border-bottom: 9px solid #fff;
  position: absolute;
  left: 40px;
  bottom: 40px;
}

.bod4 {
  /* width: 9px; */
  width: 28px;
  height: 28px;
  border-right: 9px solid #fff;
  border-bottom: 9px solid #fff;
  position: absolute;
  right: 40px;
  bottom: 40px;
}

.selects .flex_box .one:hover .mask {
  display: inline-block;
}

.selects .flex_box .one .mask:hover {
  transform: scale(1.08);
}

.selects .flex_box .item.one {
  background: #3472ef;
}

.selects .flex_box .item.two {
  background: #2556b8;
}

.selects .flex_box .item.three {
  background: #164197;
}

.selects .flex_box .item img {
  margin-top: 102px;
}

.selects .flex_box .item div {
  font-size: 35px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 32px;
  /* margin-top: 43px; */
}

/* assess */
.assess {
  height: 901px;
  background: url("../../static/img/assess.png") no-repeat center center;
  transition: all 0.5s;
}

.assess .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 87px;
  text-align: center;
  padding-top: 149px;
}

.assess .subTitle {
  font-size: 20px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #3472ef;
  line-height: 21px;
  text-align: center;
  margin-top: 27px;
}

.assess .swiper {
  margin-top: 68px;
}

.assess .swiper .box {
  width: 1346px;
  height: 258px;
  background: rgba(255, 255, 255, 0.18);
  margin: 0 auto;
}

.assess .swiper .box .text {
  font-size: 25px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 45px;
  padding: 64px 68px 0;
  text-align: center;
}

.assess .swiper .box .but {
  width: 172px;
  height: 58px;
  background: #ffffff;
  border-radius: 29px 29px 29px 29px;
  opacity: 1;
  border: 1px solid #707070;
  font-size: 25px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #3472ef;
  line-height: 58px;
  margin: 20px auto 0;
  text-align: center;
}

/* partner */
.partner {
  padding: 149px 287px;
}

.partner .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  line-height: 87px;
  text-align: center;
  transition: all 0.5s;
}

.partner .logo {
  display: flex;
  flex-wrap: wrap;
  margin-top: 107px;
  justify-content: space-between;
  padding: 46px 0 10px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  transition: all 0.5s;

  /* background-color: rgb(204, 204, 204); */
  /* background-image: url(../../static/img/logobg.jpg); */
  background-position: center;
  background-repeat: repeat;
  background-size: 100% auto;
}

.partner .logo .icon {
  font-size: 77px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #b8b8b8;
  /* margin-right: 118px; */
  text-align: center;
}

.partner .logo .icon.active {
  color: #3472ef;
}

.partner .logo .icon:nth-of-type(3) {
  margin-right: 0;
}

.partner .logo .icon:nth-of-type(6) {
  margin-right: 0;
}

.mt43 {
  margin-top: 43px;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  width: 223px;
}

.icon1 {
  width: 107px;
}

.icon2 {
  width: 104px;
}

.icon3 {
  width: 128px;
}

.icon4 {
  width: 128px;
}

.icon5 {
  width: 110px;
}

.icon6 {
  width: 127px;
}

.icon7 {
  width: 132px;
}

.icon8 {
  width: 249px;
}

.icon9 {
  width: 211px;
}

.icon10 {
  width: 124px;
}

.icon11 {
  width: 85px;
}

.icon12 {
  width: 105px;
}

img {
  max-width: 100%;
}

body,
div,
img,
ul,
li {
  margin: 0;
  padding: 0;
}

body {
  font-size: 12px;
  background-color: #DDD;
  min-width: 1200px;
}

ul,
ul li {
  list-style: none;
}

.clear {
  clear: both;
}





div,
img {
  margin: 0;
  padding: 0;
}

body {
  background-color: #DDD;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 700px;
  margin: 100px auto;
}

.line1,
.line2 {
  display: flex;
}

.line2 {
  margin-top: -55px;
}

.box1,
.box2,
.box3 {
  width: 200px;
  height: 250px;
  overflow: hidden;
}

.box1 {
  transform: rotate(120deg);
  margin-left: 10px;
}

.box2 {
  transform: rotate(-60deg);
}

.box3 {
  transform: rotate(-60deg);
}

.box3 img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue